<template>
    <div class="HomePage">
      <div style="width: 100%; height: 100%">
        <div class="pageTitle">
          <div class="titleBg">
            <div class="titleBox">
              <div class="boxImg"><img :src="imgLogo" /></div>
              <div class="boxStyle">
                <i class="iconfont icondidian"></i>
                <span class="titleCity">{{ weather.district }}</span>
                <span class="titleWeather">{{$t('HomPage.weather')}}</span>
                {{ weather.temperature }}
              </div>
            </div>
            <div class="titleStyle">{{$t('HomPage.ForkliftIntelligentManagementPlatform')}}</div>
            <div class="titleBox">
              <div class="boxRight">
                <div class="rightInfo">
                  <span class="infoTxt">{{ date }}</span>
                  <span class="infoTxt">{{ week }}</span>
                  <span class="infoTxt">{{ time }}</span>
                  <span class="titleBtn" @click="toggleFullScreen">
                    <i
                    :class="
                      this.iFullScreen
                        ? 'iconfont iconchuangkouhuanyuan'
                        : 'iconfont iconfangda'
                    "
                    :title="$t('HomPage.toggleFullScreen')"
                    
                  >
                  </i>{{ this.iFullScreen ? this.$t('HomPage.exitFullScreen') : this.$t('HomPage.fullScreen') }}
                  </span>
                  <span class="titleBtn" @click="btnEnter"
                    ><i class="iconfont iconicon-houtaiguanli"></i>{{$t('HomPage.backManagement')}}</span
                  >
                </div>
                
              </div>
            </div>
          </div>
        </div>
        <el-row style="height: 93%">
          <el-col :span="6" class="homeLeft">
            <div class="upBox">
              <div class="leftUp">
                <div class="upAll">
                  <div class="title">
                    <i class="iconfont icon-tongji"></i
                    ><span>{{ $t("HomPage.comStatistics") }}</span>
                  </div>
                  <div>
                    <div v-if="isValue" v-loading="carLoading">
                      <linegraph
                        :id="'carBargraph'"
                        :data="carOption"
                        style="height: 115px"
                      ></linegraph>
                    </div>
                    <div
                      v-else
                      style="
                        color: #868686;
                        font-size: 16px;
                        text-align: center;
                        line-height: 115px;
                      "
                    >
                      {{$t('common.noData')}}
                    </div>
                  </div>
                  <div class="upFlex">
                    <div class="flexHalf">
                      <div class="half" @click="btnCount">
                        <div class="halfTitle">
                          {{ carExpirationCount }}<span>{{ $t("HomPage.forklift") }}</span>
                        </div>
                        <div class="halfNum">
                          {{ $t("HomPage.todayWork") }}
                        </div>
                      </div>
                      <div class="half" @click="btnCharge">
                        <div class="halfTitle">
                          {{ batteryChargeCount
                          }}<span>{{ $t("HomPage.forklift") }}</span>
                        </div>
                        <div class="halfNum">{{$t('HomPage.chargeCar')}}{{$t('HomPage.cars')}}</div>
                      </div>
                      <div class="half" @click="btnNear">
                        <div class="halfTitle">
                          {{ nearExpirationCount
                          }}<span>{{ $t("HomPage.forklift") }}</span>
                        </div>
                        <div class="halfNum">{{$t('HomPage.maintainAdventCar')}}{{$t('HomPage.cars')}}</div>
                      </div>
                    </div>
                    <div class="flexHalf">
                      <div class="half" @click="btnFail">
                        <div class="halfTitle">
                            {{ problemCount }}<span>{{ $t("HomPage.forklift") }}</span>
                          </div>
                          <div class="halfNum">
                            {{ $t("HomPage.failTower") }}
                          </div>
                      </div>
                      <div class="half" @click="btnWork">
                        <div class="halfTitle">
                          {{ batteryWorkCount
                          }}<span>{{ $t("HomPage.forklift") }}</span>
                        </div>
                        <div class="halfNum">{{$t('HomPage.workCar')}}{{$t('HomPage.cars')}}</div>
                      </div>
                      <div class="half" @click="btnOver">
                        <div class="halfTitle">
                          {{ overExpirationCount
                          }}<span>{{ $t("HomPage.forklift") }}</span>
                        </div>
                        <div class="halfNum">{{$t('HomPage.maintainExceedCar')}}{{$t('HomPage.cars')}}</div>
                      </div>
                    </div>
                    <div class="flexHalf">
                      <div class="half" @click="btnViola">
                        <div class="halfTitle">
                          {{ alarmCount }}<span>{{ $t("HomPage.forklift") }}</span>
                        </div>
                        <div class="halfNum">
                          {{ $t("HomPage.violaTower") }}
                        </div>
                      </div>
                      <div class="half" @click="btnFree">
                        <div class="halfTitle">
                          {{ batteryFreeCount
                          }}<span>{{ $t("HomPage.forklift") }}</span>
                        </div>
                        <div class="halfNum">{{$t('HomPage.leisureCar')}}{{$t('HomPage.cars')}}</div>
                      </div>
                      <div class="half" @click="btnExpiration">
                        <div class="halfTitle">
                          {{ driverExpirationCount
                          }}<span>{{ $t("HomPage.unit") }}</span>
                        </div>
                        <div class="halfNum">{{$t('HomPage.licensesAdventValue')}}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="downBox">
              <div class="leftDown">
                <div class="upAll">
                  <div style="height: 60%">
                    <div class="title">
                      <i class="iconfont icon-weiguichuli"></i
                      ><span>{{ $t("HomPage.violationToday") }}</span>
                    </div>
                    <div class="downViolation">
                      <linegraph
                        v-loading="dayLoading"
                        :id="'dayBargraph'"
                        :data="dayOption"
                        style="height: 200px"
                      ></linegraph>
                    </div>
                  </div>
                  <div style="height: 40%">
                    <div class="oneTitle">
                      <i class="iconfont icon-weiguichuli"></i
                      ><span>{{$t('HomPage.todayFault')}}</span>
                    </div>
                    <div class="downFault">
                      <div class="fault">
                        <div class="faultNum">
                          {{ problem.FilterPluggingCount }}
                        </div>
                        <div class="faultTxt">{{$t('HomPage.FilterPluggingCount')}}</div>
                      </div>
                      <div class="fault">
                        <div class="faultNum">
                          {{ problem.LowOilPressureCount }}
                        </div>
                        <div class="faultTxt">{{$t('HomPage.LowOilPressureCount')}}</div>
                      </div>
                      <div class="fault">
                        <div class="faultNum">{{ problem.LowPowerCount }}</div>
                        <div class="faultTxt">{{$t('HomPage.LowPowerCount')}}</div>
                      </div>
                      <div class="fault">
                        <div class="faultNum">
                          {{ problem.LowLiquidLevelCount }}
                        </div>
                        <div class="faultTxt">{{$t('HomPage.LowLiquidLevelCount')}}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-col>
          <el-col :span="12" class="homeCenter">
            <div id="allmap" ref="allmap" style="width: 100%; height: 100%"></div>
          </el-col>
          <el-col :span="6" class="homeRight">
            <div class="rightBox" style="padding: 10px 10px 5px">
              <div class="rightUp">
                <div class="upAll">
                  <div class="title">
                    <i class="iconfont icon-paiming"></i
                    ><span>{{$t('HomPage.todayCarWorkTimeRank')}}</span>
                  </div>
                  <div style="width: 100%; padding: 10px 0 0">
                    <Table
                      :height="height"
                      :list="list"
                      ref="carTable"
                      :options="option"
                      :columns="columns"
                    ></Table>
                  </div>
                </div>
              </div>
            </div>
            <div class="rightBox" style="padding: 5px 10px 10px">
              <div class="rightDown">
                <div class="upAll">
                  <div class="title">
                    <i class="iconfont icon-paiming"></i
                    ><span>{{$t('HomPage.todayDriverWorkTimeRank')}}</span>
                  </div>
                  <div style="width: 100%; padding: 10px 0 0">
                    <Table
                      :height="height"
                      :list="driveList"
                      ref="carTable"
                      :options="option"
                      :columns="driveColumns"
                    ></Table>
                  </div>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </template>
  
  <script>
  import HomeTwo from "./HomeTwo.js";
  export default HomeTwo;
  </script>
  
  <style lang="less" scoped>
  @import url("./HomeTwo.less");
  </style>
  